import { styled } from '@mui/material/styles';
import Icon from '@mui/material/Icon';
import palette from '@/theme/palette';

type Variant = 'info' | 'success' | 'warning' | 'error';

interface SnackbarContentProps {
  variant: Variant;
}

export const SnackbarContent = styled('div')<SnackbarContentProps>`
  display: flex;
  flex-direction: column;
  width: 26rem;
  background-color: ${(props) => palette.snackbar.background[props.variant]};
  color: ${(props) => palette.snackbar.color[props.variant]};
  padding: 0.8rem;
  border-radius: 0.25rem;
  box-shadow: 0 7px 23px 0 ${palette.snackbar.boxShadowColor};
`;

export const StyledIcon = styled(Icon)<{ variant: Variant }>`
  margin-right: 0.875rem;
  color: ${(props) => palette.snackbar.icon[props.variant]};
`;

export const Container = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const MessageIcon = styled('div')`
  display: flex;
`;

export const MessageContainer = styled('div')`
  display: flex;
  flex-direction: column;
  font-size: 1rem;
  cursor: pointer;
`;

export const Title = styled('div')`
  font-weight: bold;
`;

export const Content = styled('div')``;

export const Left = styled('div')`
  display: flex;
  align-items: flex-start;
`;
